import { useField } from 'formik'
import Input from './Input'

const FormikInput = ({ label, required, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <Input
      {...field}
      {...props}
      label={label}
      required={required}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  )
}

export default FormikInput

